import React from 'react';
import { getInitials } from '../../../common/common';

const RadialProgressAvatar = ({ imageUrl, completion = 0, size = 112, firstName, lastName,ispercentage=true }) => {
  // --- Style Adjustments ---
  const strokeWidth = 4; // Made the ring thicker
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * Math.PI * 2;
  const dashOffset = circumference - (circumference * completion) / 100;

  return (
    <div className="flex flex-col transform   items-center w-fit">
      <div className="relative" style={{ width: size, height: size }}>
         {ispercentage&&(
      <p className="absolute left-[50%] bg-white z-10 p-1 bottom-[-9px] transform translate-x-[-50%] rounded-md shadow-style font-bold text-gray-333 text-sm sm:text-xs md:text-xs lg:text-xs xl:text-xs 2xl:text-xs ">{completion}%</p>
      )}
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          className="transform"
          style={{ transform: 'rotate(-270deg)' }}
        >
          <defs>
            {/* --- Corrected Gradient --- */}
            {/* The gradient is now diagonal (x2 and y2 are 100%) with the correct teal colors */}
            <linearGradient id="progressGradientTeal" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#eafff7" />   {/* Tailwind's emerald-200 */}
              <stop offset="100%" stopColor="#047857" /> {/* Tailwind's emerald-800 */}
            </linearGradient>
          </defs>

          {/* Background Track Circle */}
          <circle
            className="stroke-gray-100" // Use a lighter gray for a softer track
            fill="transparent"
            strokeWidth={strokeWidth}
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />

          {/* Progress Indicator Circle */}
          <circle
            fill="transparent"
            stroke="url(#progressGradientTeal)" // Apply the new gradient
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            r={radius}
            cx={size / 2}
            cy={size / 2}
            style={{
              strokeDasharray: circumference,
              strokeDashoffset: dashOffset,
              transition: 'stroke-dashoffset 0.5s ease-out'
            }}
          />
        </svg>

        {/* --- Avatar or Initials --- */}
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={getInitials(firstName, lastName)}
            className="absolute rounded-full p-1"
            style={{
              width: size - strokeWidth * 2,
              height: size - strokeWidth * 2,
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
            }}
          />
        ) : (
          <div
            className="absolute flex items-center justify-center rounded-full mph-primary font-bold select-none"
            style={{
              width: size - strokeWidth * 2,
              height: size - strokeWidth * 2,
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: Math.max(18, (size - strokeWidth * 2) / 2.5)
            }}
            aria-label={getInitials(firstName, lastName)}
          >
            {getInitials(firstName, lastName)}
          </div>
        )}
      </div>
 
    </div>
  );
};

export default RadialProgressAvatar;